import React, { useState } from 'react'
import NotificationCard from './NotificationCard'
import { useWindowSize } from '../../../modules/Dashboard'
import { MOBILE_SIZE } from '../../../core/constants/common'
import ModalLayout from '../../../components/layouts/ModalLayout'
import NotificationDetails from './NotificationDetails'
import MobileModal from '../../../components/layouts/MobileModal'

const NotificationsListing = ({ notifications, onNotifClick, isReadLoading }) => {
    const { width } = useWindowSize()
    const [modal, setModal] = useState({ show: false, data: null })
    const onCloseModal = () => setModal({ show: false, data: null })

    const onOpenModal = (notif) => {
        setModal({
            show: true, data: notif
        })
        if (!notif.readAt) {
            onNotifClick(notif._id)
        }
    }

    return (
        <div className='grid grid-cols-1 gap-4'>
            {
                notifications.map((notif) => {
                    return (
                        <NotificationCard full key={notif?._id} notif={notif} onClick={onOpenModal} isReadLoading={isReadLoading} />
                    )
                })
            }
            {
                width >= MOBILE_SIZE ?
                    <ModalLayout open={modal?.show} onClose={onCloseModal} width={"600px"}>
                        <NotificationDetails notification={modal?.data} onClose={onCloseModal} />
                    </ModalLayout> :
                    <MobileModal isOpen={modal?.show} onClose={onCloseModal} >
                        <NotificationDetails notification={modal?.data} onClose={onCloseModal} />
                    </MobileModal>
            }
        </div>
    )
}

export default NotificationsListing


